import type { TranslationKey } from '@/common/types';

const matchStageTranslationMap: Record<string, TranslationKey> = {
  matchweek: 'PreMatchStats.Stage.Matchweek',
  round: 'PreMatchStats.Stage.Round',
  round_of_16: 'PreMatchStats.Stage.RoundOf16',
  round_of_32: 'PreMatchStats.Stage.RoundOf32',
  round_of_64: 'PreMatchStats.Stage.RoundOf64',
  quarter_final: 'PreMatchStats.Stage.QuarterFinal',
  semi_final: 'PreMatchStats.Stage.SemiFinal',
  final: 'PreMatchStats.Stage.Final',
  third_place: 'PreMatchStats.Stage.ThirdPlace',
  qualification_round: 'PreMatchStats.Stage.QualificationRound',
  play_off_round: 'PreMatchStats.Stage.PlayOffRound',
  group_stage: 'PreMatchStats.Stage.GroupStage',
  league_phase: 'PreMatchStats.Stage.LeaguePhase',
};

export default matchStageTranslationMap;
